/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { useContext } from 'react';

import { ContextualHelp, Grid, Typography2, breakpoints } from '@coursera/cds-core';

import { ProfileContext } from 'bundles/account-profile/components/recruiting-profile-viewer/ProfileContextProvider';
import ProfileViewerCard from 'bundles/account-profile/components/recruiting-profile-viewer/ProfileViewerCard';
import CoursesInfoDialog from 'bundles/account-profile/components/recruiting-profile-viewer/components/courses/CoursesInfoDialog';
import CoursesSectionBody from 'bundles/account-profile/components/recruiting-profile-viewer/components/courses/CoursesSectionBody';

import _t from 'i18n!nls/account-profile';

const styles = {
  withBottomMargin: css`
    margin-bottom: var(--cds-spacing-300);

    ${breakpoints.down('sm')} {
      margin-bottom: var(--cds-spacing-200);
    }
  `,

  withTopMargin: css`
    ${breakpoints.down('xs')} {
      margin-top: var(--cds-spacing-200);
    }
  `,

  withMarginLeft: css`
    margin-left: var(--cds-spacing-300);
  `,
};

const CoursesSection = () => {
  const { isProfileLoading, profileState = {} } = useContext(ProfileContext);
  const {
    courseraHistory = {
      completedCourses: [],
    },
  } = profileState;

  if (isProfileLoading || !courseraHistory?.completedCourses?.length) {
    return null;
  }

  return (
    <ProfileViewerCard>
      <Grid container alignItems="center" justifyContent="space-between" css={styles.withBottomMargin}>
        <ContextualHelp
          helpToggleProps={{
            'aria-label': _t('Information about the courses section'),
          }}
          label={
            <Typography2 variant="subtitleLarge" component="h3">
              {_t('Courses')}
            </Typography2>
          }
        >
          {({ onClose, isExpanded = false }) => <CoursesInfoDialog isOpen={isExpanded} onClose={onClose} />}
        </ContextualHelp>
      </Grid>
      <CoursesSectionBody />
    </ProfileViewerCard>
  );
};

export default CoursesSection;
